export default {"src":"/_next/static/media/enj.db8816fd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};